<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { ComboboxAnchorProps } from 'reka-ui'
import { reactiveOmit } from '@vueuse/core'
import { ComboboxAnchor, useForwardProps } from 'reka-ui'
import { cn } from '@ds/lib/utils'

/*
 * The frame — same metrics as DSInput and DSSelectTrigger, so a combobox reads
 * as one more field in the grid: 40px, card fill, ds radius, Iris ring on focus
 * within. The registry's fixed `w-[200px]` is a demo width and is dropped.
 */
const props = defineProps<ComboboxAnchorProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')

const forwarded = useForwardProps(delegatedProps)
</script>

<template>
  <ComboboxAnchor
    v-bind="forwarded"
    :class="cn(
      'flex h-10 w-full min-w-0 items-center gap-2 px-3',
      'bg-card border border-input rounded-ds-md',
      'transition-[border-color,box-shadow] duration-ds-fast ease-ds-standard',
      // The frame owns the ring: the input inside drops its own, exactly as
      // DSInputGroup does.
      'focus-within:border-ring focus-within:shadow-ds-focus',
      'has-[[data-disabled]]:bg-muted has-[[data-disabled]]:cursor-not-allowed',
      props.class,
    )"
  >
    <slot />
  </ComboboxAnchor>
</template>
